import API from "./api";

export const PLACEHOLDER_IMAGE = `${API.base}${process.env.REACT_APP_PLACEHOLDER_IMAGE}`;
